import { render, staticRenderFns } from "./appStart.vue?vue&type=template&id=befe2cd4&"
import script from "./appStart.vue?vue&type=script&lang=js&"
export * from "./appStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports